module.exports = __webpack_public_path__ + "img/ocio.c8cbd0a0.jpg";